import { CategoriesApi } from '../types/api/categories-api';
import { NetworkResponse } from '../types/services/request.types';
import { RequestHandler } from './requestHandler.service';

export class SprykerCategoriesByBusinessHandler extends RequestHandler {
  api = {
    target: 'spryker-categories-by-business',
    default: 'spryker-default',
  };

  fetchCategoriesByBusiness(
    url: string,
  ): NetworkResponse<CategoriesApi.ProductsAllCategoriesCategory[]> {
    return this.get<CategoriesApi.ProductsAllCategoriesCategory[]>(
      url,
    );
  }
}

export const SprykerCategoriesByBusiness = new SprykerCategoriesByBusinessHandler();
